import { ReactComponent as BinanceIcon } from "assets/binanceIcon.svg";
import { ReactComponent as PaypalIcon } from "assets/paypalIcon.svg";

export const paymentMethodDictionary = {
  pay_pal: { name: "Pay Pal", icon: <PaypalIcon /> },
  binance: { name: "Binance", icon: <BinanceIcon /> },
};

export enum PaymentTypes {
  Deposit = "deposit",
  TopUp = "top_up",
  Withdraw = "withdraw",
  Donate = "donate",
  Subscribe = "subscribe",
  PaidStream = "paid_stream",
}
